import { Box, Button, Typography } from '@mui/material';
import { useAnalytics } from 'contexts/Analytics/Analytics';
import { useContent } from 'contexts/Content/Content';
import Image from '../Image/Image';

export default function GamePromo() {
    const analytics = useAnalytics();
    const content = useContent();

    if (!content.game.promo) {
        return null;
    }

    const { buttonLabel, image, imageAlt, link, text, title } = content.game.promo;

    function handleClick() {
        void analytics.trackActionEvent('krobar_ad_clicked', {
            destination_url: link,
            resource_id: 'krobar_completion_promo',
            resource_type: 'ad',
            source: 'game_promo',
        });
    }

    return (
        <a
            aria-label={buttonLabel}
            data-testid="game-promo-link"
            href={link}
            onClick={handleClick}
            rel="noopener noreferrer"
            style={{ textDecoration: 'none' }}
            target="_blank"
        >
            <Box
                alignItems="center"
                border="1px solid #E5DED0"
                borderRadius={3}
                display="flex"
                flexDirection={{ xs: 'column', sm: 'row' }}
                gap={3}
                padding={3}
                sx={{ backgroundColor: '#F7F4EF' }}
            >
                <Box alignItems="center" display="flex" justifyContent="center" minWidth={{ sm: 160 }}>
                    <Image alt={imageAlt} maxWidth={180} src={image} />
                </Box>
                <Box display="flex" flexDirection="column" gap={1.5}>
                    <Typography color="#1F1F1F" variant="montserrat524">
                        {title}
                    </Typography>
                    <Typography color="#4E4E4E" variant="montserrat518">
                        {text}
                    </Typography>
                    <Box>
                        <Button component="span">{buttonLabel}</Button>
                    </Box>
                </Box>
            </Box>
        </a>
    );
}
